import React from "react";
import CreateParty from "../../internal/CreateParty/CreateParty";

const Index = ({ draftId }) => {
  return <CreateParty draftId={draftId} />;
};

export default Index;
